import { Component, Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

import testimonialCardFields from 'organisms/Cards/Testimonial/config';

const testimonialsFields = [
  {
    name: 'id',
    type: 'string',
    required: true,
    showIf: 'false',
    helperText: 'Internal ID for this testimonials block. Not visible to users.',
  },
  ...sectionFields,
  {
    name: 'testimonials',
    type: 'list',
    subFields: [
      {
        name: 'id',
        type: 'string',
        required: true,
        showIf: 'false',
        helperText: 'Internal ID for each testimonial. Not visible to users.',
      },
      ...testimonialCardFields,
    ],
    helperText: 'Add up to 10 testimonials. Each item can include quote text, author, and optional image.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('testimonials').length > 10) {
        options.set('testimonials', options.get('testimonials').slice(0, 10));
        alert('Maximum testimonial count is 10. Removing excess testimonials.');
      }
    },
  },
] as const satisfies DeepReadonly<Input[]>;

const testimonialsConfig = {
  name: 'testimonials',
  inputs: testimonialsFields,
} as Component;

export type TestimonialsConfigProps = GenerateBuilder<typeof testimonialsFields>;
export default testimonialsConfig;
